import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { ApplicationRoute } from '../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { PanelAPI } from '@philips-internal/oswald-ui-components';

@Controller({ component: 'layout-patient-evolution-submit', fragment: 'patient-evolution-submit' })
class EvolutionPatientController extends BaseController {

  @Inject('panel-release')
  panelRelease!: PanelAPI;

  @Inject('panel-release-submit')
  panelOneRelease!: PanelAPI;

  @OnClick({ target: 'release-submit-evolution' })
  onClickRelease(): void {

    const cdEvolucao = this.context.get('cdEvolucao');
    HttpService.put(Endpoint.PATIENT_EVOLUTION, { cdEvolucao }).then(response => {
      if (response.status === 200 && response.body === true) {
        applicationContext.redirect(ApplicationRoute.ELECTRONIC_PATIENT_CHART +
          ApplicationRoute.PATIENT_LIST +
          ApplicationRoute.CLINICAL_NOTES_LIST);
      }
    });
  }
}

export default EvolutionPatientController;
